import { ITransferDocumentAppropriation } from '../types';

type CurrentUser = { id: number, is_superuser?: boolean } | null;

export const activeAppropriation = (
  appropriations: ITransferDocumentAppropriation[],
) => appropriations.find(appropriation => !appropriation.end_date) || null;

export const canReviewDocuments = (
  appropriation: ITransferDocumentAppropriation | null,
  user: CurrentUser,
) => !!(appropriation && user && appropriation.user.id === user.id);

export const canTransferAppropriation = (
  appropriation: ITransferDocumentAppropriation | null,
  user: CurrentUser,
) => !!(
  appropriation
  && user
  && (appropriation.user.id === user.id || user.is_superuser)
);
